import {log} from '@/core/utils/log'

window.log = log
